import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SearchForm from '../components/SearchForm';
import { vehicleService } from '../services/api';
import './SearchPage.css';

const SearchPage = () => {
  const navigate = useNavigate();
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadVehicles();
  }, []);

  const loadVehicles = async () => {
    try {
      setLoading(true);
      const response = await vehicleService.getAll();
      setVehicles(response.data.data || []);
    } catch (error) {
      console.error('Error loading vehicles:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewVehicle = () => {
    navigate('/buscar');
  };

  return (
    <div className="search-page">
      <div className="hero-section">
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>Alquiler de autos en Buenos Aires</h1>
            <p>Disfrutá de cada destino con libertad, seguridad y una experiencia única</p>
            
            <SearchForm />
            
            <p className="search-hint">Seleccioná tu ubicación y fechas para buscar vehículos disponibles.</p>
            <div className="residence-selector">
              <span>Residencia</span>
              <select className="country-select">
                <option>🇦🇷 Argentina</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className="vehicles-section">
        <div className="container">
          <div className="vehicles-header">
            <h2>Explorá nuestra flota</h2>
            <p className="vehicles-subtitle">Encontrá el vehículo perfecto para tu viaje</p>
          </div>

          {loading ? (
            <div className="loading-vehicles">Cargando vehículos...</div>
          ) : (
            <div className="vehicles-grid">
              {vehicles.map((vehicle) => (
                <div key={vehicle.id} className="vehicle-fleet-card">
                  <div className="vehicle-fleet-card-image">
                    <img 
                      src={vehicle.image || '/placeholder-car.svg'} 
                      alt={vehicle.name}
                      onError={(e) => {
                        e.target.src = '/placeholder-car.svg';
                      }}
                    />
                  </div>
                  
                  <div className="vehicle-fleet-card-content">
                    <h3 className="vehicle-fleet-card-title">{vehicle.name}</h3>
                    <p className="vehicle-fleet-card-category">{vehicle.category}</p>
                    
                    <div className="vehicle-fleet-card-features">
                      {vehicle.features?.passengers && (
                        <span className="feature-item">
                          <span className="feature-icon">👥</span>
                          {vehicle.features.passengers}
                        </span>
                      )}
                      {vehicle.features?.doors && (
                        <span className="feature-item">
                          <span className="feature-icon">🚪</span>
                          {vehicle.features.doors}
                        </span>
                      )}
                      {vehicle.features?.luggage && (
                        <span className="feature-item">
                          <span className="feature-icon">🧳</span>
                          {vehicle.features.luggage}
                        </span>
                      )}
                      {vehicle.features?.transmission && (
                        <span className="feature-item">
                          <span className="feature-icon">⚙️</span>
                          {vehicle.features.transmission}
                        </span>
                      )}
                    </div>

                    {vehicle.price && (
                      <div className="vehicle-fleet-card-price">
                        <span className="price-label">Desde</span>
                        <span className="price-value">${vehicle.price.toLocaleString()}/día</span>
                      </div>
                    )}

                    <button 
                      className="vehicle-fleet-card-button"
                      onClick={handleViewVehicle}
                    >
                      RESERVAR AHORA
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {!loading && vehicles.length === 0 && (
            <div className="no-vehicles">
              <p>No hay vehículos disponibles en este momento.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchPage;
